import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/base/_global.scss';
import './i18n/i18n'; // Import the i18n configuration
import 'tailwindcss/tailwind.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
